import _ from "underscore";

import { addOrRemove } from "@exo/helpers";

import { 
	updateDynamicFilters
} from "actions/searchActions.js";

import { setActiveChatConfig } from 'actions/chatActions';

import {
	CLOSE_DATA_EXPLORER_CONTENT_MODAL,
	CLOSE_DATA_EXPLORER_PDF_MODAL,
	CLOSE_DATA_EXPLORER_BAR_CHART_MODAL,
	DATA_EXPLORER_RESET_TABLE_CURSOR_POS,
	DATA_EXPLORER_SET_SEARCHES_INITIALIZED,
	DATA_EXPLORER_SET_TABLE_CURSOR_POS,
	DATA_EXPLORER_SET_TABLE_SORT,
	FETCHING_DATA_EXPLORER_CONTENT_MODAL_DATA,
	OPEN_DATA_EXPLORER_CONTENT_MODAL,
	OPEN_DATA_EXPLORER_PDF_MODAL,
	OPEN_DATA_EXPLORER_BAR_CHART_MODAL,
	RESET_DOCUMENT_SUMMARIZATION,
	SET_DATA_EXPLORER_DASHBOARD_EXPANDED,
	SET_DATA_EXPLORER_CONTENT_EXPANDED,
	SET_DATA_EXPLORER_ENTITIES_EXPANDED,
	DATA_EXPLORER_SET_DATASETS_EXPANDED,
	DATA_EXPLORER_SET_REQUESTED_DOC_DATA,
	TOGGLE_DATA_EXPLORER_TRANSLATION,
	SET_DATA_EXPLORER_ENTITIES,
} from "actions/constants.js";

import { toggleFilter } from "lib/helpers/webPagesHelpers.js";
import { combineDataExlorerFilters } from "lib/helpers/dataExplorerHelpers.js";

import { 
	fetchDataExplorerEntities, 
	fetchDataExplorerDocument, 
	fetchDataExplorerPDFData, 
	updateDataExplorerEntities,
} from "actions/fetch";

import { 
	explorerNavigation, 
	connectorNavigation,
} from "actions/navigation";

import { 
	CONNECTOR_ROUTE, 
	EXPLORER_ROUTE, 
	ENTITY_DISPLAY_PATHS,
} from "constants/constants.js";

import { SET_CURRENT_DATA_EXPLORER_DATASET_ID } from "./constants";

import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

const stateId = SEARCH_STATE_IDS.EXPLORER;

export const updateDataExplorerResults = () => {
	return (dispatch, getState) => {
		// FLAG_CONVERT_DATAEXPLORER_TO_GRAPH_QL - once GQL is installed, it will subscribe to queryString instead of fetching here
		dispatch(updateDataExplorerEntities());
		// Update Dynamic Filters
		dispatch(updateDynamicFilters(stateId));
	};
};

export const toggleDataExplorerTranslation = () => {
	return {
		type: TOGGLE_DATA_EXPLORER_TRANSLATION,
	};
};

// ------- Expanded bar graph modal --------
export const closeDataExplorerBarGraphModal = () => {
	return {
		type: CLOSE_DATA_EXPLORER_BAR_CHART_MODAL,
	};
};
export const openDataExplorerBarChartModal = (graphData) => {
	return {
		type: OPEN_DATA_EXPLORER_BAR_CHART_MODAL,
		graphData,
	};
};

// ------- Data Explorer Content modal --------
export const closeDataExplorerContentModal = () => {
	return (dispatch, getState) => {
		const { currentDatasetId } = getState().dataExplorer;
		const { lastNavMode } = getState().base;
		const { location } = getState().router;
		dispatch({ type: CLOSE_DATA_EXPLORER_CONTENT_MODAL });
		dispatch({ type: RESET_DOCUMENT_SUMMARIZATION });
		dispatch(setActiveChatConfig("single", null));
		const isEntityDisplayPath = ENTITY_DISPLAY_PATHS.find(x => location?.pathname.startsWith(x));
		if (!isEntityDisplayPath) {
			if (lastNavMode === CONNECTOR_ROUTE) {
				dispatch(connectorNavigation())
			}
			else if (lastNavMode === EXPLORER_ROUTE) {
				dispatch(explorerNavigation(currentDatasetId));
			}
		}
	};
};
export const openDataExplorerContentModal = ({dataset, index, id}) => {
	return (dispatch, getState) => {
		// Initialize single doc chat config if opening without any pre-loaded config
		const { activeConfigs } = getState().chat;
		if (!activeConfigs["single"]) {
			dispatch(setActiveChatConfig("single", {dataset}));
		}
		dispatch({ type: FETCHING_DATA_EXPLORER_CONTENT_MODAL_DATA });
		dispatch({ type: OPEN_DATA_EXPLORER_CONTENT_MODAL });
		dispatch(fetchDataExplorerDocument({dataset, index, id}));
	};
};
export const fetchDataExplorerContentModalData = ({dataset, index, id}) => {
	return (dispatch) => {
		dispatch({ type: FETCHING_DATA_EXPLORER_CONTENT_MODAL_DATA });
		dispatch(fetchDataExplorerDocument({dataset, index, id}));
	};
};

// ------- Data Explorer PDF modal --------
export const closeDataExplorerPDFModal = () => {
	return (dispatch, getState) => {
		const { currentDatasetId } = getState().dataExplorer;
		const { lastNavMode } = getState().base;
		const { location } = getState().router;
		dispatch({ type: CLOSE_DATA_EXPLORER_PDF_MODAL });
		dispatch({ type: RESET_DOCUMENT_SUMMARIZATION });
		dispatch(setActiveChatConfig("single", null));
		const isEntityDisplayPath = ENTITY_DISPLAY_PATHS.find(x => location?.pathname.startsWith(x));
		if (!isEntityDisplayPath) {
			if (lastNavMode === CONNECTOR_ROUTE) {
				dispatch(connectorNavigation())
			}
			else if (lastNavMode === EXPLORER_ROUTE) {
				dispatch(explorerNavigation(currentDatasetId));
			}
		}
	};
};
export const openDataExplorerPDFModal = ({id, index, dataset}) => {
	return (dispatch, getState) => {
		const content = {id, index, dataset};
		// Initialize single doc chat config if opening without any pre-loaded config
		const { activeConfigs } = getState().chat;
		if (!activeConfigs["single"]) {
			dispatch(setActiveChatConfig("single", {dataset}));
		}
		// Open the modal
		dispatch({
			type: OPEN_DATA_EXPLORER_PDF_MODAL,
			content,
		});
		// Get the data to populate the modal
		dispatch(fetchDataExplorerPDFData(content));
	};
};

// FLAG_CONVERT_DATAEXPLORER_TO_GRAPH_QL
export const clearDataExplorerTags = ({ savedSearches }) => {
	const fetchKey = `explorerRequest_${Date.now()}`;
	return (dispatch, getState) => {
		const { queryString, queryId, filterTypeIds, endDate, startDate } = getState().dataExplorer;

		// rebuild filterMaps so that they invalidate
		const updatedFilterMaps = {};
		_.each(filterTypeIds, (filterId) => {
			updatedFilterMaps[filterId] = new Map();
		});

		// dispatch({ type: SET_DATA_EXPLORER_FILTERS, filterMaps: updatedFilterMaps });
		dispatch({ type: SET_DATA_EXPLORER_ENTITIES, entityFilters: [] });
		dispatch(fetchDataExplorerEntities({ queryString, filtersList: [], endDate, startDate, fetchKey }));
	};
};
export const removeDataExplorerFilter = ({ id, clickedFilter, savedSearches }) => {
	const fetchKey = `explorerRequest_${Date.now()}`;
	return (dispatch, getState) => {
		const { queryString, queryId, filterMaps, filterTypeIds, entityFilters, endDate, startDate } = getState().dataExplorer;

		// rebuild filterMaps so that they invalidate
		const updatedFilterMaps = {};
		_.each(filterTypeIds, (filterId) => {
			updatedFilterMaps[filterId] = filterMaps[filterId];
		});

		updatedFilterMaps[id].delete(clickedFilter.id);

		const filtersList = combineDataExlorerFilters({ filterTypeIds, entityFilters, filterMaps: updatedFilterMaps });

		// dispatch({ type: SET_DATA_EXPLORER_FILTERS, filterMaps: updatedFilterMaps });
		dispatch(fetchDataExplorerEntities({ queryString, filtersList, endDate, startDate, fetchKey }));
	};
};
export const toggleInclusiveDataExplorerFilter = ({ id, clickedFilter, savedSearches }) => {
	const fetchKey = `explorerRequest_${Date.now()}`;
	return (dispatch, getState) => {
		const { queryString, queryId, filterMaps, filterTypeIds, entityFilters, endDate, startDate } = getState().dataExplorer;

		// rebuild filterMaps so that they invalidate
		const updatedFilterMaps = {};
		_.each(filterTypeIds, (filterId) => {
			updatedFilterMaps[filterId] = filterMaps[filterId];
		});

		updatedFilterMaps[id] = toggleFilter({ filterMap: updatedFilterMaps[id], filter: clickedFilter });

		const filtersList = combineDataExlorerFilters({ filterTypeIds, entityFilters, filterMaps: updatedFilterMaps });

		// dispatch({ type: SET_DATA_EXPLORER_FILTERS, filterMaps: updatedFilterMaps });
		dispatch(fetchDataExplorerEntities({ queryString, filtersList, endDate, startDate, fetchKey }));
	};
};
export const toggleExclusiveDataExplorerFilter = ({ id, clickedFilter, savedSearches }) => {
	const fetchKey = `explorerRequest_${Date.now()}`;
	return (dispatch, getState) => {
		const { queryString, queryId, filterMaps, filterTypeIds, entityFilters, endDate, startDate } = getState().dataExplorer;

		// rebuild filterMaps so that they invalidate
		const updatedFilterMaps = {};
		_.each(filterTypeIds, (filterId) => {
			updatedFilterMaps[filterId] = filterMaps[filterId];
		});

		updatedFilterMaps[id] = toggleFilter({ filterMap: updatedFilterMaps[id], filter: clickedFilter, exclusive: true });

		const filtersList = combineDataExlorerFilters({ filterTypeIds, entityFilters, filterMaps: updatedFilterMaps });

		// dispatch({ type: SET_DATA_EXPLORER_FILTERS, filterMaps: updatedFilterMaps });
		dispatch(fetchDataExplorerEntities({ queryString, filtersList, endDate, startDate, fetchKey }));
	};
};

export const toggleDataExplorerEntity = ({ entity, savedSearches }) => {
	const fetchKey = `explorerRequest_${Date.now()}`;
	return (dispatch, getState) => {
		const { queryString, queryId, filterMaps, filterTypeIds, entityFilters, endDate, startDate } = getState().dataExplorer;

		let updatedEntityFilters = JSON.parse(JSON.stringify(entityFilters));
		updatedEntityFilters = addOrRemove(updatedEntityFilters, entity, "name");

		const filtersList = combineDataExlorerFilters({ filterTypeIds, entityFilters: updatedEntityFilters, filterMaps });

		dispatch({ type: SET_DATA_EXPLORER_ENTITIES, entityFilters: updatedEntityFilters });
		dispatch(fetchDataExplorerEntities({ queryString, filtersList, endDate, startDate, fetchKey }));
	};
};

export const setCurrentDatasetId = (datasetId, explorerDatasets) => {
	return (dispatch, getState) => {
		dispatch({ 
			type: SET_CURRENT_DATA_EXPLORER_DATASET_ID, 
			id: datasetId, 
			explorerDatasets
		});
	}
};

export const setDashboardExpanded = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_DATA_EXPLORER_DASHBOARD_EXPANDED, expanded})
	}
};

export const setContentExpanded = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_DATA_EXPLORER_CONTENT_EXPANDED, expanded });
	}
}

export const setEntitiesExpanded = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_DATA_EXPLORER_ENTITIES_EXPANDED, expanded });
	}
}

export const setTableCursorPosition = (pos, offset) => {
	return { type: DATA_EXPLORER_SET_TABLE_CURSOR_POS, pos, offset };
}

export const resetTableCursorPosition = () => {
	return { type: DATA_EXPLORER_RESET_TABLE_CURSOR_POS };
}

export const updateTableDataByHeader = (columnId) => {
	const getDefaultSortAscending = () => {
		switch (columnId) {
			case "age":
			case "date":
			case "totalDocumentTermsCount":
				return false;
			default:
				return true;
		}
	}
	return (dispatch, getState) => {
		const {
			tableSortType,
			tableSortAscending,
		} = getState().dataExplorer;
		const ascending = !columnId ? tableSortAscending 
			: (columnId === tableSortType) 
				? !tableSortAscending 
				: getDefaultSortAscending();
		const sortBy = columnId || tableSortType;
		dispatch({
			type: DATA_EXPLORER_SET_TABLE_SORT,
			sortType: sortBy,	
			sortAscending: ascending,
		});
	};
};

export const setSearchesInitialized = (state) => {
	return { type: DATA_EXPLORER_SET_SEARCHES_INITIALIZED, state };
}

export const setRequestedDocData = (dataset, index, id) => {
	return { type: DATA_EXPLORER_SET_REQUESTED_DOC_DATA, dataset, index, id };
}

export const setDatasetsExpanded = (expanded) => {
	return (dispatch) => {
		dispatch({ type: DATA_EXPLORER_SET_DATASETS_EXPANDED, expanded });
	}
}